import _ from "lodash";
import generateAvatarSVG from "./generate-avatar-svg";

//appends progress to cycle based on the programs progresses
function appendProgressToCycle(cycle) {
  if (!cycle.progressStatuses)
    cycle.progressStatuses = cycle.programs.map((program) => program.progress);
  // TODO Refactor!!! to a switch?
  cycle.progress = "Unscheduled";

  if (cycle.progressStatuses.includes("Draft")) cycle.progress = "Draft";
  if (cycle.progressStatuses.includes("Pushed")) cycle.progress = "Pushed";
  if (cycle.progressStatuses.includes("Completed"))
    cycle.progress = "Completed";
  if (cycle.progressStatuses.includes("Upcoming")) cycle.progress = "Upcoming";
  if (cycle.progressStatuses.includes("In Progress"))
    cycle.progress = "In Progress";

  return cycle;
}

const getCards = ({
  cycles,
  programType,
  cardType,
  progressFilter,
  programOwner,
  filters,
}) => {
  // Disregard programs in cycles of the wrong type(premium, user coach etc)
  if (programType && programType !== "all")
    cycles = _.filter(cycles, (cycle) => programType.includes(cycle.type));

  // Filter templates from athlete-specific programs
  if (programOwner && programOwner !== "all") {
    cycles = _.filter(cycles, (cycle) => {
      const ownedByCoach =
        String(cycle.owner._id) === String(cycle.createdBy._id);
      return (programOwner === "coach") === ownedByCoach;
    });
  }

  // Filter out the cycle cards based on progress
  const isProgramUnscheduledInCoachMode = (cycle, program) => {
    return (
      cycle.type === "coach" &&
      cycle.status === "created" &&
      (!program.progress || program.progress === "Unscheduled")
    );
  };
  cycles = cycles.map((cycle) => {
    cycle.progressStatuses = cycle.programs.map((program) => {
      if (isProgramUnscheduledInCoachMode(cycle, program))
        return program.status === "pushed" ? "Pushed" : "Draft";
      return program.progress;
    });
    return appendProgressToCycle(cycle);
  });

  cycles = cycles.filter((cycle) => {
    if (progressFilter) {
      return cycle.progressStatuses.indexOf(progressFilter) > -1;
    }
    // if not progress filter, then include all
    return true;
  });

  if (filters) {
    const authorFilter = filters["cycleAuthorId"];
    if (authorFilter && authorFilter !== "any") {
      cycles = cycles.filter((cycle) => {
        return cycle.createdBy._id === authorFilter;
      });
    }
  }

  if (cardType !== "programs") return cycles;

  // Create an array of programs from the union of all cycle.programs, and attach info about their cycle.
  let programs = _.union(
    ..._.map(cycles, (cycle) => {
      const {
        createdBy: { name },
      } = cycle;
      const [firstName, lastName] = name.split(" ");
      return _.map(cycle.programs, (program) => {
        program.cycleId = cycle._id;
        program.cycleImage = _.get(cycle, "image.file", false)
          ? "/api/file/" + cycle.image.file
          : generateAvatarSVG(firstName, lastName);
        program.cycleName = cycle.name;
        program.cycleAuthor = cycle.createdBy.name;
        program.cycleOwnerName = cycle.owner.name;
        program.cycleOwnerId = cycle.owner._id;
        program.cycleOwnerAvatar = cycle.owner.avatar;
        program.cycleAuthorId = cycle.createdBy._id;
        program.cycleType = cycle.type;
        program.cycleStatus = cycle.status;
        // program.orderInCycle = cycle.programs.indexOf(program) + 1;
        program.cycleProgramTotal = cycle.programs.length;
        return program;
      });
    })
  );

  // Filter out by program progress tracking
  programs = progressFilter
    ? programs.filter((program) => {
        return (
          program.progress === progressFilter ||
          (program.progress === "Unscheduled" && program.status === "pushed"
            ? progressFilter === "Pushed"
            : progressFilter === "Draft")
        );
      })
    : programs;

  return programs;
};

export default getCards;
